export const mentionTypes = [
    {title: 'Chats', description: 'Chat logs', value: 'CHAT'},
    {title: 'DMs', description: 'Direct messages', value: 'DIRECT_MESSAGE'},
    {title: 'Emails', description: 'Company emails', value: 'EMAIL'},
    {title: 'Internal', description: 'Internal company data e.g surveys', value: 'INTERNAL'},
];